import React, { useState } from "react";
import tw from "tailwind-styled-components";
import Loading from "../Loading";
import axios from "axios";
import Config from "../../Config";

const Tables = ({
  editEntryLoading,
  setEditNotification,
  selectedData,
  ApiData,
  editNotificationMutate,
  updateNotification,
}) => {
  const [toggleState, setToggleState] = useState({
    whatsApp: ApiData.whatsApp === 1,
    sms: ApiData.sms === 1,
    rentReminder: ApiData.rentReminder === 1,
    onboardWelcome: ApiData.onboardWelcome === 1,
    partialPayment: ApiData.partialPayment === 1,
    onlinePayment: ApiData.onlinePayment === 1,
    isWhatsSelfBranding: ApiData.isWhatsSelfBranding === 1,
    isSMSSelfBranding : ApiData.isSMSSelfBranding === 1,
  });

  // console.log(toggleState);
  console.log("notifff", ApiData);

  const handleToggle = (key) => {
    const updatedState = { ...toggleState, [key]: !toggleState[key] };
    setToggleState(updatedState);

    // Send API request to update the notification setting
    editNotificationMutate(updatedState);
  };

  return (
    <Wrapper>
      {editEntryLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : (
        <>
          {/* WhatsApp Notification */}
          <OptionGroup>
            <OptionHeader>
              <OptionTitle>WhatsApp Notifications</OptionTitle>
              <ToggleWrapper>
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={toggleState.whatsApp}
                    onChange={() => handleToggle("whatsApp")}
                    className="sr-only peer"
                  />
                  <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </ToggleWrapper>
            </OptionHeader>
            <OptionDescription>
              Enable this to receive important updates and notifications through
              WhatsApp messages.
            </OptionDescription>
          </OptionGroup>

          {/* SMS Notification */}
          <OptionGroup>
            <OptionHeader>
              <OptionTitle>SMS Notifications</OptionTitle>
              <ToggleWrapper>
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={toggleState.sms}
                    onChange={() => handleToggle("sms")}
                    className="sr-only peer"
                  />
                  <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </ToggleWrapper>
            </OptionHeader>
            <OptionDescription>
              Enable this to receive important updates and notifications through
              SMS.
            </OptionDescription>
          </OptionGroup>

          {/* Rent Reminder */}
          <OptionGroup>
            <OptionHeader>
              <OptionTitle>Rent Reminder</OptionTitle>
              <ToggleWrapper>
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={toggleState.rentReminder}
                    onChange={() => handleToggle("rentReminder")}
                    className="sr-only peer"
                  />
                  <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </ToggleWrapper>
            </OptionHeader>
            <OptionDescription>
              Enable this to receive important reminders for rent payments.
            </OptionDescription>
          </OptionGroup>

          {/* Onboard Welcome */}
          <OptionGroup>
            <OptionHeader>
              <OptionTitle>Onboard Welcome</OptionTitle>
              <ToggleWrapper>
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={toggleState.onboardWelcome}
                    onChange={() => handleToggle("onboardWelcome")}
                    className="sr-only peer"
                  />
                  <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </ToggleWrapper>
            </OptionHeader>
            <OptionDescription>
              Enable this to receive a welcome message upon onboarding.
            </OptionDescription>
          </OptionGroup>

          {/* Partial Payment */}
          <OptionGroup>
            <OptionHeader>
              <OptionTitle>Partial Payment</OptionTitle>
              <ToggleWrapper>
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={toggleState.partialPayment}
                    onChange={() => handleToggle("partialPayment")}
                    className="sr-only peer"
                  />
                  <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </ToggleWrapper>
            </OptionHeader>
            <OptionDescription>
              Enable this to receive notifications for partial payments.
            </OptionDescription>
          </OptionGroup>

          {/* Online Payment */}
          <OptionGroup>
            <OptionHeader>
              <OptionTitle>Online Payment</OptionTitle>
              <ToggleWrapper>
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={toggleState.onlinePayment}
                    onChange={() => handleToggle("onlinePayment")}
                    className="sr-only peer"
                  />
                  <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </ToggleWrapper>
            </OptionHeader>
            <OptionDescription>
              Enable this to receive notifications about online payments.
            </OptionDescription>
          </OptionGroup>
          {/* iswhatsapp */}
          <OptionGroup>
            <OptionHeader>
              <OptionTitle>isWhatsSelfBranding</OptionTitle>
              <ToggleWrapper>
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={toggleState.isWhatsSelfBranding}
                    onChange={() => handleToggle("isWhatsSelfBranding")}
                    className="sr-only peer"
                  />
                  <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </ToggleWrapper>
            </OptionHeader>
            <OptionDescription>
              Enable this to receive notifications about online payments.
            </OptionDescription>
          </OptionGroup>
          {/* issmsselfbranding */}
          <OptionGroup>
            <OptionHeader>
              <OptionTitle>isSMSSelfBranding </OptionTitle>
              <ToggleWrapper>
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={toggleState.isSMSSelfBranding }
                    onChange={() => handleToggle("isSMSSelfBranding ")}
                    className="sr-only peer"
                  />
                  <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </ToggleWrapper>
            </OptionHeader>
            <OptionDescription>
              Enable this to receive notifications about online payments.
            </OptionDescription>
          </OptionGroup>
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = tw.div`px-6 pt-1 space-y-6 bg-white mt-6`;
const OptionGroup = tw.div`border-b last:border-b-0 pb-4 mb-4`;
const OptionHeader = tw.div`flex justify-between items-center`;
const OptionTitle = tw.h3`text-gray-700 font-medium`;
const ToggleWrapper = tw.div`flex items-center space-x-4`;
const OptionDescription = tw.p`text-gray-500 text-sm mt-2`;

export default Tables;
